module.exports = "/assets/img/ipallets/A_ienter_logo_500px.png";